export function sanitizeFilenamePrefix(name) {
  return (name || '')
    .replace(/\s+/g, '_')
    .replace(/[^a-zA-Z0-9_-]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '') || 'Location';
}

export function padSequence(n) {
  return String(n).padStart(3, '0');
}

export function sortImagesForBadge(images) {
  return [...images].sort(
    (a, b) =>
      (a.sort_order || 0) - (b.sort_order || 0) ||
      String(a.id).localeCompare(String(b.id)),
  );
}

export function deriveImageFilenames(images, categories) {
  const nameById = {};
  (categories || []).forEach((cat) => { nameById[cat.id] = cat.name; });

  const groups = {};
  (images || []).forEach((img) => {
    const key = img.category_id || 'uncategorized';
    (groups[key] = groups[key] || []).push(img);
  });

  const filenameById = {};
  Object.keys(groups).forEach((key) => {
    const prefix = key === 'uncategorized' ? 'Uncategorized' : sanitizeFilenamePrefix(nameById[key]);
    sortImagesForBadge(groups[key]).forEach((img, index) => {
      filenameById[img.id] = `${prefix}_${padSequence(index + 1)}`;
    });
  });

  return (images || []).map((img) => ({ ...img, filename: filenameById[img.id] ?? img.filename }));
}
